var vw = $(".l-page-main-contents__detail").width();
$('.company-history__wrapper').css('width', vw);

$(window).resize(function () {
  var vw = $(".l-page-main-contents__detail").width();
  $('.company-history__wrapper').css('width', vw);
});